import { render, staticRenderFns } from "./NewDefectPopup.vue?vue&type=template&id=a33757e6&scoped=true&"
import script from "./NewDefectPopup.vue?vue&type=script&lang=js&"
export * from "./NewDefectPopup.vue?vue&type=script&lang=js&"
import style0 from "./NewDefectPopup.vue?vue&type=style&index=0&id=a33757e6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33757e6",
  null
  
)

export default component.exports